import { FetchResult, useMutation, MutationResult } from '@apollo/client'
import { deleteWorkerTipInput } from '__generated__/globalTypes'

import {
  DeleteWorkerTipMessage,
  DeleteWorkerTipMessageVariables
} from '__generated__/DeleteWorkerTipMessage'

import DELETE_WORKER_TIP from '../__graphql__/DeleteWorkerTipMessage.graphql'

export type DeleteWorkerTipResult = FetchResult<DeleteWorkerTipMessage>

export type UseDeleteWorkerTipReturn = [
  (input: deleteWorkerTipInput) => Promise<DeleteWorkerTipResult>,
  MutationResult<DeleteWorkerTipMessage>
]

export default function useDeleteWorkerTip(): UseDeleteWorkerTipReturn {
  const [mutation, result] = useMutation<
    DeleteWorkerTipMessage,
    DeleteWorkerTipMessageVariables
  >(DELETE_WORKER_TIP)

  const deleteWorkerTip = (
    input: deleteWorkerTipInput
  ): Promise<DeleteWorkerTipResult> => {
    return mutation({
      variables: {
        input
      }
    })
  }

  return [deleteWorkerTip, result]
}

export { useDeleteWorkerTip }
